import { createRouter as createVueRouter, createWebHistory } from 'vue-router'
import routerObj from './constants/basicRouterObject'
import _ from 'lodash'

export const createRouter = async () => {
  const newRouterObject = _.cloneDeep(routerObj)
  return createVueRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: newRouterObject.routes,
    scrollBehavior: newRouterObject.scrollBehavior
  })
}
